/* Sydney Mirrors — <sm-countdown>
   Markup comes from snippets/countdown__v2.liquid, which also prints the first
   values so nothing flashes at 00 while this loads. Liquid output is cached,
   though, so the element re-reads the clock straight away and every second
   after.

   At zero it either holds at 00 or hides, per Theme settings > Sale countdown.
   Hiding takes out the nearest [data-countdown-scope] ancestor when there is
   one (the marquee marks its whole bar), otherwise just the timer. */

(function () {
  if (window.customElements.get('sm-countdown')) return;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  class SmCountdown extends HTMLElement {
    connectedCallback() {
      this.end = Date.parse(this.dataset.end);
      if (isNaN(this.end)) return;

      this.nums = {};
      this.querySelectorAll('[data-unit]').forEach((el) => {
        this.nums[el.dataset.unit] = el;
      });

      this.tick();
      this.timer = window.setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
    }

    tick() {
      const left = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
      const days = Math.floor(left / 86400);
      const values = {
        days: days,
        hours: Math.floor((left % 86400) / 3600),
        minutes: Math.floor((left % 3600) / 60),
        seconds: left % 60
      };

      Object.keys(values).forEach((unit) => {
        const el = this.nums[unit];
        const text = pad(values[unit]);
        if (el && el.textContent !== text) el.textContent = text;
      });

      this.toggleAttribute('data-has-days', days > 0);

      if (left === 0) {
        window.clearInterval(this.timer);
        this.expire();
      }
    }

    expire() {
      if (this.dataset.expired !== 'hide') return;
      const scope = this.closest('[data-countdown-scope]') || this;
      scope.style.display = 'none';
    }
  }

  window.customElements.define('sm-countdown', SmCountdown);
})();
